<div class="user-access-avatar-container"
  capraTooltip
  tooltipPlacement="bottom"
  [tooltipContent]="tooltipContent"
  [tooltipContentIsHtml]="true"
>
  <capra-avatar *ngIf="avatar"
    type="user"
    size="extra-small"
    [options]="avatar"
  ></capra-avatar>

  <div class="access-icon-container">
    <capra-icon
      [class]="icon"
      [icon]="icon"
    ></capra-icon>
  </div>
</div>

<div class="divider"></div>
